<div class="v3-member-list">
  @if (isLoaderActive) {
    <div class="v3-member-list__loader">
      <div class="v3-member-list__loader-inner">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>
    </div>
  }

  @if (members?.length) {
    <div class="v3-member-list__card">
      <div class="v3-member-list__scroll">
        <table class="v3-member-list__table" [attr.aria-label]="'translations.global.ariaLabels.usersList' | transloco">
          <thead class="v3-member-list__thead">
            <tr>
              @if (isColumnEnabled('SELECT')) {
                <th class="v3-member-list__th v3-member-list__th--checkbox" id="v3-h-select" scope="col">
                  <mat-checkbox
                    color="primary"
                    [(ngModel)]="allUsersChecked"
                    [tabIndex]="0"
                    (change)="onAllCheckboxChange()"
                    [attr.aria-label]="
                      allUsersChecked
                        ? ('translations.global.ariaLabels.uncheckAllUsers' | transloco)
                        : ('translations.global.ariaLabels.checkAllUsers' | transloco)
                    "
                  ></mat-checkbox>
                </th>
              }
              @if (isColumnEnabled('FIRST_NAME')) {
                <th
                  class="v3-member-list__th v3-member-list__th--sortable"
                  id="v3-h-first-name"
                  scope="col"
                  tabindex="0"
                  role="button"
                  (keydown.enter)="changeListOrdering('firstName')"
                  (click)="changeListOrdering('firstName')"
                >
                  <span class="v3-member-list__th-label">
                    {{ 'translations.global.label.firstName' | transloco }}
                    <span class="v3-member-list__sort-indicator">
                      @if (defaultOrderBy === 'firstName') {
                        {{ order === 'ASC' ? '↑' : '↓' }}
                      } @else {
                        <span class="v3-member-list__sort-indicator--inactive">↕</span>
                      }
                    </span>
                  </span>
                </th>
              }
              @if (isColumnEnabled('LAST_NAME')) {
                <th
                  class="v3-member-list__th v3-member-list__th--sortable"
                  id="v3-h-last-name"
                  scope="col"
                  tabindex="0"
                  role="button"
                  (keydown.enter)="changeListOrdering('lastName')"
                  (click)="changeListOrdering('lastName')"
                >
                  <span class="v3-member-list__th-label">
                    {{ 'translations.global.label.lastName' | transloco }}
                    <span class="v3-member-list__sort-indicator">
                      @if (defaultOrderBy === 'lastName') {
                        {{ order === 'ASC' ? '↑' : '↓' }}
                      } @else {
                        <span class="v3-member-list__sort-indicator--inactive">↕</span>
                      }
                    </span>
                  </span>
                </th>
              }
              @if (isColumnEnabled('EMAIL')) {
                <th class="v3-member-list__th" id="v3-h-email" scope="col">
                  {{ 'translations.global.label.email' | transloco }}
                </th>
              }
              @if (isColumnEnabled('ROLES')) {
                <th class="v3-member-list__th" id="v3-h-roles" scope="col">
                  {{ 'translations.global.label.role' | transloco }}
                </th>
              }
              @if (isColumnEnabled('GROUPS')) {
                <th class="v3-member-list__th" id="v3-h-groups" scope="col">
                  {{ 'translations.global.label.group' | transloco }}
                </th>
              }
              @if (isColumnEnabled('LAST_ACTIVE')) {
                <th
                  class="v3-member-list__th v3-member-list__th--sortable"
                  id="v3-h-last-active"
                  scope="col"
                  tabindex="0"
                  role="button"
                  (keydown.enter)="changeListOrdering('lastActiveOn')"
                  (click)="changeListOrdering('lastActiveOn')"
                >
                  <span class="v3-member-list__th-label">
                    {{ 'translations.global.label.lastActive' | transloco }}
                    <span class="v3-member-list__sort-indicator">
                      @if (defaultOrderBy === 'lastActiveOn') {
                        {{ order === 'ASC' ? '↑' : '↓' }}
                      } @else {
                        <span class="v3-member-list__sort-indicator--inactive">↕</span>
                      }
                    </span>
                  </span>
                </th>
              }
              @if (isColumnEnabled('JOIN_DATE')) {
                <th
                  class="v3-member-list__th v3-member-list__th--sortable"
                  id="v3-h-join-date"
                  scope="col"
                  tabindex="0"
                  role="button"
                  (keydown.enter)="changeListOrdering('createdAt')"
                  (click)="changeListOrdering('createdAt')"
                >
                  <span class="v3-member-list__th-label">
                    {{ 'translations.global.label.joinDate' | transloco }}
                    <span class="v3-member-list__sort-indicator">
                      @if (defaultOrderBy === 'createdAt') {
                        {{ order === 'ASC' ? '↑' : '↓' }}
                      } @else {
                        <span class="v3-member-list__sort-indicator--inactive">↕</span>
                      }
                    </span>
                  </span>
                </th>
              }
              <th class="v3-member-list__th" id="v3-h-status" scope="col">
                {{ 'translations.global.label.status' | transloco }}
              </th>
              <th class="v3-member-list__th v3-member-list__th--actions" id="v3-h-actions" scope="col" aria-hidden="true"></th>
            </tr>
          </thead>
          <tbody>
            @for (member of members; track member._id) {
              <tr
                class="v3-member-list__row"
                tabindex="0"
                role="button"
                (mouseover)="setHoveredMember(member._id)"
                (mouseleave)="resetHoveredMember()"
                (focus)="setHoveredMember(member._id)"
                [class.is-hovered]="hoveredUserUid === member._id"
                [class.is-highlighted]="member._id === highlightedMemberId"
                [attr.aria-label]="
                  'translations.global.ariaLabels.openUserRecord' | transloco: { title: member.firstName + ' ' + member.lastName }
                "
                (keydown.enter)="openUserRecordByUid(member)"
                (click)="openUserRecordByUid(member)"
              >
                @if (isColumnEnabled('SELECT')) {
                  <td class="v3-member-list__td v3-member-list__td--checkbox" [headers]="'v3-h-select'">
                    <mat-checkbox
                      color="primary"
                      [tabIndex]="0"
                      [checked]="member.checked"
                      (change)="onCheckboxChange(member._id)"
                      (click)="$event.stopPropagation()"
                      [attr.aria-label]="
                        member.checked
                          ? ('translations.global.ariaLabels.uncheck' | transloco: { name: member.firstName + ' ' + member.lastName })
                          : ('translations.global.ariaLabels.check' | transloco: { name: member.firstName + ' ' + member.lastName })
                      "
                    ></mat-checkbox>
                  </td>
                }

                @if (isColumnEnabled('FIRST_NAME')) {
                  <td class="v3-member-list__td v3-member-list__td--first-name" [headers]="'v3-h-first-name'">
                    <div class="v3-member-list__name-cell">
                      @if (member.imageUrl) {
                        <img
                          class="v3-member-list__avatar v3-member-list__avatar--image"
                          [src]="member.imageUrl"
                          [alt]="member.firstName"
                        />
                      } @else {
                        <div class="v3-member-list__avatar" aria-hidden="true">
                          {{ getMemberInitials(member.firstName, member.lastName) }}
                        </div>
                      }
                      <span class="v3-member-list__name" matTooltip="{{ member.firstName }}" matTooltipClass="medium-tooltip">
                        {{ member.firstName }}
                      </span>
                    </div>
                  </td>
                }

                @if (isColumnEnabled('LAST_NAME')) {
                  <td class="v3-member-list__td v3-member-list__td--last-name" [headers]="'v3-h-last-name'">
                    <span matTooltip="{{ member.lastName }}" matTooltipClass="medium-tooltip">{{ member.lastName }}</span>
                  </td>
                }

                @if (isColumnEnabled('EMAIL')) {
                  <td class="v3-member-list__td v3-member-list__td--email" [headers]="'v3-h-email'">
                    <span matTooltip="{{ member.email }}" matTooltipClass="medium-tooltip">{{ member.email }}</span>
                  </td>
                }

                @if (isColumnEnabled('ROLES')) {
                  <td class="v3-member-list__td v3-member-list__td--role" [headers]="'v3-h-roles'">
                    @if (member.roles?.length) {
                      <span class="v3-member-list__role-pill">{{ getRoleLabel(member.roles) }}</span>
                    }
                  </td>
                }

                @if (isColumnEnabled('GROUPS')) {
                  <td class="v3-member-list__td v3-member-list__td--groups" [headers]="'v3-h-groups'">
                    @if (member.groups?.length) {
                      <span
                        class="v3-member-list__group"
                        [matTooltip]="showExpandedContent(member, 'GROUPS')"
                        matTooltipClass="medium-tooltip"
                      >
                        {{ member.groups[0].title }}
                      </span>
                    }
                  </td>
                }

                @if (isColumnEnabled('LAST_ACTIVE')) {
                  <td class="v3-member-list__td v3-member-list__td--last-active" [headers]="'v3-h-last-active'">
                    <span>{{ member.lastActiveOn | smartDateFormat: 'd MMM yyyy' }}</span>
                  </td>
                }

                @if (isColumnEnabled('JOIN_DATE')) {
                  <td class="v3-member-list__td v3-member-list__td--joined" [headers]="'v3-h-join-date'">
                    <span>{{ member.createdAt | dateFormat: 'D MMM YYYY' }}</span>
                  </td>
                }

                <td class="v3-member-list__td v3-member-list__td--status" [headers]="'v3-h-status'">
                  @let active = isMemberActive(member);
                  <span class="v3-member-list__status" [attr.data-state]="active ? 'active' : 'inactive'">
                    <span class="v3-member-list__status-dot"></span>
                    @if (active) {
                      {{ 'translations.global.label.active' | transloco }}
                    } @else {
                      {{ 'translations.global.label.inactive' | transloco }}
                    }
                  </span>
                </td>

                <td class="v3-member-list__td v3-member-list__td--actions" [headers]="'v3-h-actions'">
                  <button
                    class="v3-member-list__open-btn"
                    type="button"
                    (click)="openUserRecordByUid(member); $event.stopPropagation()"
                    (keydown.enter)="openUserRecordByUid(member); $event.stopPropagation()"
                    [attr.aria-label]="
                      'translations.global.ariaLabels.openUserRecord' | transloco: { title: member.firstName + ' ' + member.lastName }
                    "
                  >
                    {{ 'translations.global.button.open' | transloco }} →
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (paginationLength) {
        <div class="v3-member-list__footer">
          <ptl-pagination-footer
            [totalItems]="membersTotalCount"
            [pageSize]="pageSize"
            [currentPage]="currentPage + 1"
            (pageChange)="onPageChangeEvent($event)"
            (pageSizeChange)="onSizeChange($event)"
          ></ptl-pagination-footer>
        </div>
      }
    </div>
  } @else {
    <div class="v3-member-list__empty">
      <div class="v3-member-list__empty-inner">
        <div class="v3-member-list__empty-title">
          {{ 'translations.membersNew.list.table.noUsersFound' | transloco }}
        </div>
        <div class="v3-member-list__empty-text">
          {{ 'translations.membersNew.list.table.noUsersFoundDescription' | transloco }}
        </div>
      </div>
    </div>
  }
</div>
